














































































































import {Vue, Component, Provide} from 'vue-property-decorator';
import {mapActions} from 'vuex';
import {Utils} from '@/utils/Utils';
import {API} from '@/services/api/api';
import {redirectTime} from '@/constants/constants';

@Component({
  methods: {...mapActions(['showSuccessToast', 'showErrorToast'])},
})
export default class UploadBackgroundImage extends Vue {
  //Store Variables
  showSuccessToast: any;
  showErrorToast: any;

  //Form Variables
  imageStatus: any = null;
  imagebase64URL = '';
  imageName = '';
  bgImageId: any = null;

  //other variables
  imageValidationMsg: any = null;

  //Loader Variables
  loadingBtnStatus = false;
  isScreenLoading = true;

  mounted() {
    this.bgImageId = Number.parseInt(this.$route.params.id);

    this.getBgImageDetails();
  }

  //get particular bgImage details
  async getBgImageDetails() {
    try {
      let apiResponse = await API.fetchBgImageDetailsById(this.bgImageId);
      this.isScreenLoading = false;
      let imgHeader = 'data:image/png;base64,';
      if (apiResponse.data) {
        this.imageName = apiResponse.data.bgImageName;
        let imageURL = apiResponse.data.bgImagePath;
        this.imagebase64URL = imgHeader.concat(imageURL);
        this.imageStatus = apiResponse.data.bgImageIsActive;
      } else {
        this.showErrorToast({msg: apiResponse.error});
      }
    } catch (error) {
      this.isScreenLoading = false;
      this.showErrorToast({msg: 'Network error'});
    }
  }

  //convert image into base 64 string and display on screen
  async onFileChange(event: any) {
    const imageData = event.target.files[0];
    this.imageName = imageData.name;

    try {
      let base64url = await Utils.ngxBase64(imageData);
      if (base64url === null) alert('Something went wrong with image');
      else {
        this.imageValidationMsg = null;
        return (this.imagebase64URL = base64url);
      }
    } catch (error) {
      alert('something went wrong with image.');
    }
  }

  validateImage() {
    if (this.imageName === '' || this.imagebase64URL === '') {
      this.imageValidationMsg = 'Please choose image first. ';
      return false;
    } else {
      this.imageValidationMsg = null;
      return true;
    }
  }

  //submit button handler
  async _updateHandler() {
    if (!this.validateImage()) {
      return false;
    }
    try {
      this.loadingBtnStatus = true;
      let imageurl = this.imagebase64URL.split('base64,')[1];
      let response = await API.updateBgImageDetails(this.bgImageId, this.imageName, imageurl, this.imageStatus);
      this.loadingBtnStatus = false;
      if (response.data) {
        let message: string = response.message;
        if (message.includes('updated background')) message = 'Record updated successfully';
        this.showSuccessToast({msg: message});

        setTimeout(() => this._clickHandler(), redirectTime);
      } else {
        this.showErrorToast({msg: response.error});
      }
    } catch (error) {
      this.loadingBtnStatus = false;
      this.showErrorToast({msg: 'Network error'});
    }
  }

  _clickHandler() {
    this.$router.go(-1);
  }
}
